import { cn } from "@moe/priv/utils";
import { cva, type VariantProps } from "class-variance-authority";

const chipVariants = cva("text-tx-tertiary bg-muted shrink-0 rounded font-semibold w-fit h-fit", {
  variants: {
    size: {
      sm: "px-1.5 py-0.5 text-xs",
      md: "px-2 py-0.5 text-sm"
    }
  },
  defaultVariants: {
    size: "md"
  }
});

interface Props extends VariantProps<typeof chipVariants> {
  className?: string;
  children: React.ReactNode;
}

/**
 * Displays a tiny text label with a highlighted background (a chip).
 */
export function Chip({ className, size, children }: Props) {
  return <span className={cn(chipVariants({ size }), className)}>{children}</span>;
}
